import request from '@/utils/request'

export function getDeptByUserName(username, password) {
  const data = {
    username,
    password
  };

  return request({
    url: 'web/getDeptByUserName',
    headers: {
      isToken: false
    },
    method: 'post',
    data: data
  })
}


// 登录方法
export function login(username, password, userId, code, uuid) {
  const data = {
    username,
    password,
    userId,
    code,
    uuid
  };
  return request({
    url: '/login',
    headers: {
      isToken: false
    },
    method: 'post',
    data: data
  })
}

// 注册方法
export function register(data) {
  return request({
    url: '/register',
    headers: {
      isToken: false
    },
    method: 'post',
    data: data
  })
}

// 获取用户详细信息
export function getInfo() {
  return request({
    url: '/getInfo',
    method: 'get'
  })
}

// 退出方法
export function logout() {
  return request({
    url: '/logout',
    method: 'post'
  })
}

// 获取验证码
export function getCodeImg() {
  return request({
    url: '/captchaImage',
    headers: {
      isToken: false
    },
    method: 'get',
    timeout: 20000
  })
}
